export default {
  name: 'intro-tooltip',
  props: ['widgetButtonPosition', 'message', 'isVisible', 'shouldShowUp'],
};
